// extracted by mini-css-extract-plugin
export default {"contentContainer":"ContentLayout_contentContainer__CjxJT","contentTitle":"ContentLayout_contentTitle__cITpf","contentBody":"ContentLayout_contentBody__XlzdE"};